<template>
  <BreadCrumb PageTitle="Bons de ramassage" />
  <ListPickup />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import ListPickup from "../../components/PickUp/ListPickup.vue";

export default defineComponent({
  name: "ListPickupPage",
  components: {
    BreadCrumb,
    ListPickup,
  },
});
</script>